module.exports = __webpack_public_path__ + "static/media/Golden_Circle_Logo.5404c332.png";